import styled from 'styled-components'

import { ArrowDown2Icon, Typography, useHapticFeedback } from '@blade/ui-kit'
import { CurrencyIcon } from '@root/entities/currency/ui'

import type { CurrencyModel } from '@root/entities/currency'

type TransferCardCurrencyButtonProps = {
  currency: CurrencyModel
  onClick: () => void
}

export const TransferCardCurrencyButton: React.FC<
  TransferCardCurrencyButtonProps
> = ({ currency, onClick }) => {
  const haptics = useHapticFeedback()
  return (
    <Root
      onClick={() => {
        haptics.impactOccurred('light')
        onClick()
      }}
      type="button"
    >
      <CurrencyIcon size={24} currency={currency} withGoogleLens={false} />
      <Ticker>{currency.ticker}</Ticker>
      <ArrowDown2Icon />
    </Root>
  )
}

const Root = styled.button`
  all: unset;
  cursor: pointer;
  border-radius: 64px;
  background: var(--backgroundA-3);
  padding-block: 4px;
  padding-inline: 4px 8px;

  display: grid;
  min-width: 90px;
  grid-template-columns: auto 1fr auto;
  align-items: center;
`

const Ticker = styled(Typography).attrs({
  variant: 'body4-semi-bold',
  component: 'div',
})`
  color: var(--text-11);
  padding-inline: 8px;
`
